import { render, staticRenderFns } from "./quotationDetailDialog.vue?vue&type=template&id=31e0f74d&scoped=true&"
import script from "./quotationDetailDialog.vue?vue&type=script&lang=js&"
export * from "./quotationDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./quotationDetailDialog.vue?vue&type=style&index=0&id=31e0f74d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e0f74d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31e0f74d')) {
      api.createRecord('31e0f74d', component.options)
    } else {
      api.reload('31e0f74d', component.options)
    }
    module.hot.accept("./quotationDetailDialog.vue?vue&type=template&id=31e0f74d&scoped=true&", function () {
      api.rerender('31e0f74d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/Quotation/components/quotationDetailDialog.vue"
export default component.exports